(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kd-sort]').forEach(function (sel) {
  sel.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-guide-quiz"] && !Shopify.designMode) return;
  try {
    
if (!window.__kdQuizInit) {
  window.__kdQuizInit = true;

  var QUESTIONS = [
    { q: "Tu consommes du CBD depuis…",
      opts: ["🌱 Jamais, je débute", "🙂 Quelques mois", "😎 Longtemps, je connais"] },
    { q: "Tu cherches plutôt…",
      opts: ["🍃 Un goût doux et léger", "🔥 Des arômes intenses", "💰 Le meilleur prix au gramme"] },
    { q: "Ton budget pour commencer ?",
      opts: ["Moins de 15€", "15 à 30€", "Plus de 30€"] }
  ];

  document.querySelectorAll('[data-kd-quiz]').forEach(function (quiz) {
    var step = 0, score = 0;
    var stepsEl = quiz.querySelector('[data-kd-quiz-steps]');
    var resultEl = quiz.querySelector('[data-kd-quiz-result]');
    var qnum = quiz.querySelector('[data-kd-qnum]');
    var qtext = quiz.querySelector('[data-kd-qtext]');
    var qopts = quiz.querySelector('[data-kd-qopts]');

    function render() {
      qnum.textContent = step + 1;
      qtext.textContent = QUESTIONS[step].q;
      qopts.innerHTML = QUESTIONS[step].opts.map(function (o, i) {
        return '<button type="button" class="kd-quiz-opt" data-v="' + i + '">' + o + '</button>';
      }).join('');
    }

    qopts.addEventListener('click', function (e) {
      var b = e.target.closest('.kd-quiz-opt');
      if (!b) return;
      score += Number(b.dataset.v);
      step++;
      if (step < QUESTIONS.length) { render(); return; }
      /* 0–2 débutant · 3–4 intermédiaire · 5–6 expert */
      var k = score <= 2 ? 'r1' : score <= 4 ? 'r2' : 'r3';
      stepsEl.hidden = true;
      resultEl.hidden = false;
      quiz.querySelector('[data-kd-rtitle]').textContent = quiz.dataset[k + 'Title'];
      quiz.querySelector('[data-kd-rtext]').textContent = quiz.dataset[k + 'Text'];
      quiz.querySelector('[data-kd-rcta]').href = quiz.dataset[k + 'Url'] || '#';
    });

    quiz.querySelector('[data-kd-qreset]').addEventListener('click', function () {
      step = 0; score = 0;
      stepsEl.hidden = false;
      resultEl.hidden = true;
      render();
    });

    render();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-product-grid"] && !Shopify.designMode) return;
  try {
    
if (!window.__kdPgInit) {
  window.__kdPgInit = true;

  /* Supprime temporairement tout overflow:hidden sur les parents quand le dropdown s'ouvre */
  function kdApplyPosition(details) {
    var list = details.querySelector('.kd-select-list');
    if (!list) return;
    if (details.open) {
      var saved = [];
      var el = details.parentElement;
      while (el && el !== document.body) {
        var ov = getComputedStyle(el).overflow;
        if (ov === 'hidden') {
          saved.push({ el: el, was: el.style.overflow });
          el.style.overflow = 'visible';
        }
        el = el.parentElement;
      }
      list._kdSaved = saved;
    } else {
      if (list._kdSaved) {
        list._kdSaved.forEach(function(s) { s.el.style.overflow = s.was; });
        list._kdSaved = null;
      }
    }
  }

  /* Attache le listener toggle sur tous les selects existants et futurs */
  function kdInitSelects(root) {
    (root || document).querySelectorAll('[data-kd-select]').forEach(function(d) {
      if (d._kdBound) return;
      d._kdBound = true;
      d.addEventListener('toggle', function() { kdApplyPosition(d); });
    });
  }
  kdInitSelects(document);
  new MutationObserver(function() { kdInitSelects(document); })
    .observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function(e) {
    /* Sélection d'un grammage */
    var g = e.target.closest('[data-kd-variant]:not(:disabled)');
    if (g) {
      var card = g.closest('[data-kd-card]');
      card.querySelectorAll('[data-kd-variant]').forEach(function(b) {
        b.setAttribute('aria-selected', b === g ? 'true' : 'false');
      });
      var details = card.querySelector('[data-kd-select]');
      var labelEl = details ? details.querySelector('[data-kd-selected-label]') : null;
      if (labelEl) {
        var ppg = g.dataset.ppg;
        labelEl.innerHTML = g.dataset.label + (ppg ? ' <small class="kd-ppg-inline">(' + ppg + '/g)</small>' : '');
      }
      if (details) details.removeAttribute('open');
      var vidInput = card.querySelector('.kd-vid-input');
      if (vidInput) vidInput.value = g.dataset.vid;
      var add = card.querySelector('[data-kd-add]');
      if (add) {
        var priceEl = add.querySelector('[data-kd-btnprice]');
        if (priceEl) priceEl.textContent = ' · ' + g.dataset.price;
        add.disabled = g.disabled;
      }
      return;
    }
    /* Clic dehors → ferme tout */
    if (!e.target.closest('[data-kd-select]')) {
      document.querySelectorAll('[data-kd-select][open]').forEach(function(d) {
        d.removeAttribute('open');
      });
    }
  });

  /* --- Ajout au panier AJAX --- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-kd-add]:not(:disabled)');
    if (!add) return;

    var vid = add.dataset.vid;
    if (!vid) return;

    add.disabled = true;
    var saved = add.innerHTML;

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(vid), quantity: 1 })
    })
    .then(function (r) { if (!r.ok) throw r; return r.json(); })
    .then(function () {
      add.classList.add('kd-add--done');
      var doneTxt = add.dataset.done || 'Ajouté ✓';
      var txtEl = add.querySelector('.kd-add-txt');
      if (txtEl) { txtEl.dataset.prev = txtEl.innerHTML; txtEl.textContent = doneTxt; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kd-product-grid' });
      }
      setTimeout(function () {
        add.classList.remove('kd-add--done');
        if (txtEl && txtEl.dataset.prev) txtEl.innerHTML = txtEl.dataset.prev;
        else add.innerHTML = saved;
        add.disabled = false;
      }, 1500);
    })
    .catch(function () {
      add.innerHTML = saved;
      add.disabled = false;
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-kd-pp]');
  if (!root || root.__kdInit) return;
  root.__kdInit = true;

  var form = root.querySelector('[data-kd-pform], #kd-pform');
  var vidInput = root.querySelector('[data-kd-vid]');
  var priceEl = root.querySelector('[data-kd-pp-price]');
  var ppgEl = root.querySelector('[data-kd-pp-ppg]');
  var pointsEl = root.querySelector('[data-kd-points]');
  var addBtn = root.querySelector('[data-kd-pp-add]');
  var sticky = root.querySelector('[data-kd-sticky]');
  var stickyPrice = root.querySelector('[data-kd-sticky-price]');

  root.querySelectorAll('input[name="kd-variant"]').forEach(function (r) {
    r.addEventListener('change', function () {
      vidInput.value = r.value;
      priceEl.textContent = r.dataset.price;
      var cmp = root.querySelector('[data-kd-pp-compare]');
      if (cmp) {
        if (r.dataset.compare) { cmp.textContent = r.dataset.compare; cmp.hidden = false; }
        else { cmp.hidden = true; }
      }
      ppgEl.textContent = r.dataset.ppg ? 'soit ' + r.dataset.ppg : '';
      if (pointsEl && r.dataset.points) pointsEl.textContent = r.dataset.points;
      if (stickyPrice) stickyPrice.textContent = r.dataset.price;
    });
  });

  function addToCart() {
    if (!addBtn || addBtn.disabled) return;
    addBtn.disabled = true;
    var data = new FormData(form);
    data.append('sections', 'cart-icon-bubble');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', body: data, headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { if (!r.ok) throw r; return r.json(); })
    .then(function (json) {
      if (json.sections && json.sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = json.sections['cart-icon-bubble'];
      }
      var saved = addBtn.textContent;
      addBtn.textContent = addBtn.dataset.done;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () { addBtn.textContent = saved; addBtn.disabled = false; }, 1600);
    })
    .catch(function () {
      addBtn.textContent = 'Réessaie';
      setTimeout(function () { addBtn.textContent = 'Ajouter au panier'; addBtn.disabled = false; }, 1800);
    });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  var stickyAdd = root.querySelector('[data-kd-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', addToCart);

  if (sticky && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-on', !entries[0].isIntersecting);
      sticky.setAttribute('aria-hidden', entries[0].isIntersecting);
    }, { threshold: 0 }).observe(addBtn);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
if (!window.__kdPgInit) {
  window.__kdPgInit = true;

  document.addEventListener('click', function (e) {
    /* --- Sélection d'un grammage dans le dropdown --- */
    var g = e.target.closest('[data-kd-variant]:not(:disabled)');
    if (g) {
      var card = g.closest('[data-kd-card]');

      card.querySelectorAll('[data-kd-variant]').forEach(function (b) {
        b.setAttribute('aria-selected', b === g ? 'true' : 'false');
      });

      var details = card.querySelector('[data-kd-select]');
      var labelEl = details ? details.querySelector('[data-kd-selected-label]') : null;
      if (labelEl) labelEl.textContent = g.dataset.label;
      if (details) details.removeAttribute('open');

      var add = card.querySelector('[data-kd-add]');
      if (add) {
        add.dataset.vid = g.dataset.vid;
        var priceEl = add.querySelector('[data-kd-btnprice]');
        if (priceEl) priceEl.textContent = ' · ' + g.dataset.price;
      }
      return;
    }

    /* --- Ajout au panier AJAX --- */
    var add = e.target.closest('[data-kd-add]:not(:disabled)');
    if (add) {
      add.disabled = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(add.dataset.vid), quantity: 1 })
      })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        var saved = add.innerHTML;
        add.textContent = add.dataset.done;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          add.innerHTML = saved;
          add.disabled = false;
        }, 1400);
      })
      .catch(function () {
        var saved = add.innerHTML;
        add.textContent = 'Indisponible';
        setTimeout(function () {
          add.innerHTML = saved;
          add.disabled = false;
        }, 1800);
      });
    }
  });

  /* Ferme le dropdown si on clique en dehors */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.kd-select[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
